<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-request-sidebar ref="productRequestSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button
          @click="onClickCreateNew"
          icon="add"
          type="relief"
          color="primary"
          >Create stock product request</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        pagination
        search
        :max-items="10"
        :data="mappedStockProductRequests"
      >
        <template slot="thead">
          <vs-th sort-key="number"></vs-th>
          <vs-th sort-key="displayName">Name</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>Vendor</vs-th>
          <vs-th sort-key="requestedBy">Requested by</vs-th>
          <vs-th sort-key="createdAt">Requested at</vs-th>
          <vs-th sort-key="inactive">Status</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.stockProductInformation.name">
                  {{ tr.stockProductInformation.name }}
                </div>
                <div v-else>
                  <vs-chip> No name </vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <div
                  v-if="tr.stockProductInformation.productCategoryIdentifier"
                >
                  <code>{{
                    tr.stockProductInformation.productCategoryIdentifier.name
                  }}</code>
                </div>
                <div v-else>
                  <vs-chip>No category</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.stockProductInformation.vendorIdentifier">
                  {{ tr.stockProductInformation.vendorIdentifier.name }}
                </div>
                <div v-else>
                  <vs-chip>No vendor</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip>{{ tr.requestedBy.username }}</vs-chip>
                <!-- {{ tr.requestedBy.id }} -->
              </vs-td>
              <vs-td>
                <div class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.createdAt | formatDate }}
                </div>
                <!-- {{ tr.requestedBy.id }} -->
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="
                    tr.accepted === null || tr.accepted === undefined
                      ? 'primary'
                      : tr.accepted
                      ? 'success'
                      : 'danger'
                  "
                >
                  {{
                    tr.accepted === null || tr.accepted === undefined
                      ? "Awaiting"
                      : tr.accepted
                      ? "Accepted"
                      : "Declined"
                  }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductRequestSidebar from "./HandleProductRequestSidebar";

export default {
  components: {
    HandleProductRequestSidebar,
  },
  data() {
    return {
      selected: [],
      isLoading: true,
      ProductIcon,
    };
  },
  methods: {
    async onClickCreateNew() {
      this.$refs.productRequestSidebar.showEmptyProduct();
    },
  },
  computed: {
    ...mapGetters({
      activeVenueId: "venues/activeVenueId",
      stockProductRequests: "stockProductRequests/stockProductRequests",
    }),

    mappedStockProductRequests() {
      return this.stockProductRequests
        .slice()
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch(
      "stockProductRequests/getForVenue",
      this.activeVenueId
    );
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
